<template>
    <auto-payments-destroy
        :auto-payment="tenancy.auto_payment.uuid"
        @success="onSuccess"
    >
        <button
            slot-scope="{
                is_loading: is_saving,
                error,
                destroy,
                forget
            }"
            type="button"
            @click.prevent="open"
        >
            <slot />

            <error-modal
                v-if="error"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_destroyed_modal"
                :is-open="show_destroyed_modal"
                @close="closeDestroyedModal"
            >
                <template slot="heading">Smart Payments Disabled</template>

                <p>Smart payments have been successfully disabled.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="mt-3 text-center btn md:mt-0"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_destroy_modal"
                :is-open="show_destroy_modal"
                @close="closeDestroyModal"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="destroy"
                >
                    <div class="px-4 pt-4 pb-3 sm:p-6">
                        <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                            Disable Smart Payments
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">
                                Are you sure you want to disable smart payments? We will no longer make automatic
                                payments for you when your rent is due.
                            </p>
                        </div>
                    </div>

                    <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="w-full btn btn-red md:w-auto"
                        >
                            Disable
                        </base-button>

                        <button
                            type="button"
                            class="text-center btn md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </button>
    </auto-payments-destroy>
</template>

<script>
    import _ from 'lodash'
    import * as types from '../../../../../store/types'
    import AutoPaymentsDestroy from '../../../../../components/auto-payments-destroy'

    export default {
        components: {
            AutoPaymentsDestroy
        },
        props: {
            sid: {
                type: String,
                required: true
            },
            tenancy: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_destroyed_modal: false,
                show_destroy_modal: false
            }
        },
        methods: {
            open () {
                setTimeout(() => {
                    this.show_destroy_modal = true
                }, 0)
            },
            closeDestroyModal () {
                this.show_destroy_modal = false
            },
            closeDestroyedModal () {
                setTimeout(() => {
                    this.show_destroyed_modal = false
                }, 0)

                this.$store.commit(types.tenancies.mutations.updated, {
                    sid: this.sid,
                    item: {
                        data: _.extend({}, this.tenancy, { auto_payment: null })
                    }
                })
            },
            onSuccess () {
                this.$track(
                    'dashboard.tenancies.show.auto-payments-delete-button',
                    'form-submission',
                    'A tenant has disabled auto payments.'
                )

                this.closeDestroyModal()

                setTimeout(() => {
                    this.show_destroyed_modal = true
                }, 0)
            }
        }
    }
</script>
